export default [
  {
    url:  '/',
    name: 'Статистика',
    slug: 'statistics',
    icon: 'stats',
  },
  {
    url:  '/leads',
    name: 'Лиды',
    slug: 'leads',
    icon: 'leads',
  },
];
